// @flow

import React from "react";

class ExcelExport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReport: 'PERSONAL_COMMITMENTS',
            selectedYear: ""
        };
    }

    updateSelected = (e) => {
        this.setState({selectedReport: e.target.value});
    }
    updateYear = (e) => {
        this.setState({selectedYear: e.target.value});
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <a href="/o/commitment2050-service/commitmentapi/commitments/csv">
                        Lataa kaikki sitoumukset csv-tiedostona
                    </a>
                </div>
                <br/><br/>
                <div className="col-md-12">
                    <p><h2>Sopimuskohtaiset tilastoraportit</h2></p>
                    Valitse sopimus: <nbsp/>
                    <select id="commitment_report_selector" onChange={this.updateSelected} value={this.state.selectedReport}>
                        <option value="PERSONAL_COMMITMENTS">Henkilökohtaiset sitoumukset</option>
                        <option value="COMMITMENT">Toimenpidesitoumukset (kaikki)</option>
                        <option value="COMMITMENT/TRUE">Toimenpidesitoumukset (Yritys)</option>
                        <option value="NUTRITION">Ravitsemussitoumukset</option>
                        <option value="ALL_GREEN_DEALS">Kaikki Green deal sitoumukset</option>
                        <option value="PLASTIC_BAG">Muovikassi GD</option>
                        <option value="AUTOMOTIVE_INDUSTRY">Autoala GD</option>
                        <option value="OIL_INDUSTRY">Öljyjätehuolto GD</option>
                        <option value="WORK_MACHINE">Työkoneala GD</option>
                        <option value="DEMOLITION">Purkujäte GD</option>
                        <option value="CONSTRUCTION_PLASTICS">Rakentamisen muovit GD</option>
                        <option value="EMISSION_FREE_WORKSITE">Päästötön työmaa GD</option>
                        <option value="EARLY_CHILDHOOD_EDUCATION">Varhaiskasvatuksen GD</option>
                        <option value="GREEN_DEAL">Luokittelemattomat Green dealit</option>
                        <option value="MATERIAL">Materiaalitehokkuus</option>
                        <option value="WASTEWATER">Jäteveden puhdistaminen</option>
                        <option value="GROCERY_INDUSTRY">Muoviset annospakkaukset</option>
                        <option value="GROCERY_INDUSTRY_WITH_MATERIAL">Muoviset annospakkaukset (GD & MATSIT)</option>
                    </select>
                    <br/>
                    Valitse vuosi: <nbsp/>
                    <select id="commitment_report_year" onChange={this.updateYear} value={this.state.selectedYear}>
                        <option value="">Kaikki</option>
                        <option value="2023">2023</option>
                        <option value="2022">2022</option>
                        <option value="2021">2021</option>
                        <option value="2020">2020</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                        <option value="2017">2017</option>
                        <option value="2016">2016</option>
                        <option value="2015">2015</option>
                    </select>
                </div>


                <div className="col-md-12">
                <a href={'/o/commitment2050-service/commitmentapi/commitments/csv/' + this.state.selectedReport } >Lataa valitun sopimuksen sitoumukset (huom. vuosivalinnalla ei vaikutusta)</a>
                <br/>
                <a href={'/o/commitment2050-service/commitmentapi/commitments/reports/csv/' + this.state.selectedReport + "&" + this.state.selectedYear} >Lataa sopimuksen raportoidut toimenpiteet</a>
                <br/>
                <a href={'/o/commitment2050-service/commitmentapi/commitments/reports/csv/unreported/' + this.state.selectedReport + "&" + this.state.selectedYear} >Lataa raportoimattomat CSV</a>
                </div>
            </div>

        );
    }
}


export default ExcelExport;



// WEBPACK FOOTER //
// ./src/components/maintenance/ExcelExport.js